// eslint-disable-next-line import/no-named-as-default
import posthog from "posthog-js";
import { ROZO_APP_NAME } from "./events";
var POSTHOG_KEY = process.env.POSTHOG_KEY;
var POSTHOG_HOST = process.env.POSTHOG_HOST || "https://us.i.posthog.com";
var initialized = false;
export function initAnalytics() {
    if (typeof window === "undefined" || initialized)
        return;
    if (!POSTHOG_KEY) {
        if (process.env.NODE_ENV !== "production") {
            console.warn("[analytics] POSTHOG_KEY is not set — analytics disabled.");
        }
        return;
    }
    posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
    });
    posthog.register({ app_name: ROZO_APP_NAME });
    initialized = true;
}
export function capture(event, properties) {
    if (typeof window === "undefined" || !initialized)
        return;
    posthog.capture(event, properties);
}
